module.exports = __webpack_public_path__ + "img/Z61_14.9f9ed447.jpg";